<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'businessContractList' }">
          合同列表
        </el-breadcrumb-item>
        <el-breadcrumb-item>查看合同详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <base-info-view :contract-num="contractNum" :info="info" @initInfo="initInfo" />
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="0" label="合同明细">
        <productDetail2 :is-part="false" :contract-id="info.id" :str-contract-code="contractNum" :contract-type="info.contractType" :special-product="info.specialProduct" :special-cloud-desc="info.specialCloudDesc" :multiaddress-value="info.multiaddressValue" :multiaddress="info.multiaddress" :project-name="info.projectName" :order-unit="info.orderUnit" :sold-country="info.soldCountry" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import baseInfoView from './BaseInfo';
import productDetail2 from '../components/productDetail2'; // 合同详情组件
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
export default {
  data () {
    return {
      tabsActive: '0',
      info: {}
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    baseInfoView,
    productDetail2
  },
  computed: {},
  methods: {
    initInfo (info) {
      this.info = info;
      console.log('查看info-----', info);
    }
  },
  mounted () {
  }
};
</script>
